<script setup>
defineOptions({
    inheritAttrs: false,
});

defineProps({
    label: {
        type: String,
        default: "Submit",
    },
    loading: {
        type: Boolean,
        default: false,
    },
    noSpinner: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(["click"]);
</script>

<template>
    <button
        :type="$attrs.id || 'button'"
        :name="$attrs.name"
        :class="$attrs.class || 'btn btn-primary'"
        :disabled="$attrs.disabled"
        @click="emit('click', $event)"
    >
        <slot>{{ label }}</slot>
        <span
            v-if="loading && !noSpinner"
            class="spinner-border spinner-border-sm mx-2"
            role="status"
            aria-hidden="true"
        ></span>
    </button>
</template>
